import { t } from "@/i18n-js/instance";

import { DefaultFullPreview } from "../../..";
import type { ComponentLineProps } from "../types";
import { shouldExpandFirstPayment } from "../variants/helpers";

export const SubtotalLine = ({ preview, options }: ComponentLineProps) => {
  if (
    !shouldExpandFirstPayment(preview) ||
    preview.first_payment.subtotal < 0
  ) {
    return null;
  }

  return (
    <DefaultFullPreview.PreviewEntry
      label={t("paywall_checkout.coupon.subtotal")}
      value={preview.first_payment.formatted_subtotal}
      dataTestId="checkout-form-preview-today-payment-subtotal"
      {...options}
    />
  );
};
